import { Injectable } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';

import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AnnouncerService {
  private readonly successClass = 'success-panel';
  private readonly errorClass = 'error-panel';

  constructor(private readonly snackBar: MatSnackBar, private readonly translateService: TranslateService) {
  }

  onSuccess = (message: string, isKey = true) => this.sendMessage(message, isKey, this.successClass);

  onError = (message: string, isKey = true) => this.sendMessage(message, isKey, this.errorClass);

  private sendMessage = (message: string, isKey: boolean, panelClass: string) =>
    isKey
      ? this.translateService
        .get(message)
        .subscribe(response => this.snackBar.open(response, undefined, { panelClass }))
      : this.snackBar.open(message, undefined, { panelClass });
}
